<template>
<div class="detail-page">
    <Header></Header>
    <div class="content">
        <div class="title">
            {{newsData.noticeTitle}}
        </div>
        <div class="detail" v-html="newsData.noticeContent"></div>
        <p class="sign">{{newsData.createBy}}<br><span id="online_time">{{newsData.createTime}}</span></p>
    </div>
    <Bottom></Bottom>
</div>
</template>

<script>
import Bottom from "@/components/Bottom";
import Header from "@/components/Header";

export default {
    name: "NewDetail",
    components: {Bottom, Header },
    data: function () {
        return {
            newsData: {}
        }
    },
    created() {
        this.noticeId = this.$route.params.noticeId || 0
        this.loadNoticeData()
    },
    methods: {
        loadNoticeData() {
            this.$http.get(this.$api.home.noticeDetail + '/' + this.noticeId).then((res) => {
                if (res.data.code == 200) {
                    this.newsData = res.data.data;
                }
            });
        },
    }
}
</script>

<style lang="less" scoped>
.detail-page {
    background-color: #e7e8eb;
    position: relative;
    width: 100%;
    padding-top: 80px;
    min-height: 100vh;
}

.content {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 60px;
    background-color: white;
}

.title {
    text-align: left;
    font-weight: 500;
    font-size: 22px;
    color: rgba(0,0,0,0.8);
    border-bottom: 0.5px solid #E5E5E5;
    padding: 30px 0 15px;
}

.detail {
    text-align: left;
    padding: 15px 0;
    font-size: 15px;
    line-height: 180%;
}

.detail p {
    margin: 0;
}

.sign {
    padding-top: 28px;
    text-align: right;
    line-height: 130%;
}
</style>
